// Coffee Cup Product Functionality
console.log('Product Cup JS loaded');
console.log('Body classes:', document.body.className);

class CoffeeCupProduct {
    constructor() {
    console.log('CoffeeCupProduct initialized');
    
    // State
    this.selectedSize = '8oz';
    this.selectedPrintType = 'Simple';
    this.selectedQuantity = 250;
    this.selectedWall = 'Single';
    this.requireLids = false;
    this.lidColor = 'Black';
    this.productionInputMode = 'slider';
    this.selectedProductionDays = 10;
    this.isRushed = false;
    this.deliveryDateView = null;
    
    // Live pricing cache
    this.productData = null;
    this.currentUnitPrice = 0;
    this.variantPriceCache = new Map();
    
    // Constants
      this.UNITS_PER_CARTON = 1000;
      this.UNITS_PER_CARTON_SINGLE = 1000;
      this.UNITS_PER_CARTON_DOUBLE = 500;
    this.LID_PRICE_HIGH_QTY = 0.059; // 1000+ cups
    this.LID_PRICE_LOW_QTY = 0.069;  // <1000 cups
    this.productionDayOptions = Object.freeze([2, 3, 4, 5, 7, 10]);
    this.expressTransitHours = 24;
    this.expressTransitBusinessDays = 1;
    this.stateTransitHours = Object.freeze({
      NSW: 52,
      VIC: 68,
      QLD: 96,
      SA: 77,
      TAS: 142,
      WA: 109,
      ACT: 72,
      NT: 72
    });
    this.stateTransitBusinessDays = Object.freeze({
      NSW: 2,
      VIC: 2,
      QLD: 4,
      SA: 3,
      WA: 5,
      TAS: 6,
      ACT: 3,
      NT: 4
    });
    this.productionFeePercentages = Object.freeze({
      10: 0,
      7: 15,
      5: 30,
      4: 40,
      3: 50,
      2: 60
    });
    
    // Media
    this.doubleWallHeroAlt = 'Custom Coffee Cups - Double Wall (Compostable) - Exposurepack';
    
    // Sizes that support Full Colour Print
    this.fullColourSizes = ['8oz', '12oz', '16oz'];
    // Sizes that support Double Wall
    this.doubleWallSizes = ['8oz', '12oz', '16oz'];
      
    // Variant mappings split by Wall Type
    // SINGLE WALL (existing)
    this.variantMappingSingle = {
      "4oz_Simple": {
        "250": "50664722891034",
        "500": "50682864271642",
        "1000": "50682864304410",
        "2000": "50682864337178",
        "3000": "50682864369946",
        "4000": "50682864402714",
        "5000": "50682864435482"
      },
      "6oz_Simple": {
        "250": "50664722923802",
        "500": "50682864468250",
        "1000": "50682864501018",
        "2000": "50682864533786",
        "3000": "50682864566554",
        "4000": "50682864599322",
        "5000": "50682864632090"
      },
      "8oz_Simple": {
        "250": "50664722956570",
        "500": "50682864664858",
        "1000": "50682864697626",
        "2000": "50682864730394",
        "3000": "50682864763162",
        "4000": "50682864795930",
        "5000": "50682864828698"
      },
      "8oz_FullColour": {
        "250": "51084526682394",
        "500": "51084526715162",
        "1000": "50682864894234",
        "2000": "50682864927002",
        "3000": "50682864959770",
        "4000": "50682864992538",
        "5000": "50682865025306",
        "10000": "50726861963546"
      },
      "12oz_Simple": {
        "250": "50664722989338",
        "500": "50682865058074",
        "1000": "50682865090842",
        "2000": "50682865123610",
        "3000": "50682865156378",
        "4000": "50682865189146",
        "5000": "50682865221914"
      },
      "12oz_FullColour": {
        "1000": "50682865287450",
        "2000": "50682865320218",
        "3000": "50682865352986",
        "4000": "50682865385754",
        "5000": "50682865418522",
        "10000": "50726862029082"
      },
      "16oz_Simple": {
        "250": "50664723022106",
        "500": "50682865451290",
        "1000": "50682865484058",
        "2000": "50682865516826",
        "3000": "50682865549594",
        "4000": "50682865582362",
        "5000": "50682865615130"
      },
      "16oz_FullColour": {
        "1000": "50682865680666",
        "2000": "50682865713434",
        "3000": "50682865746202",
        "4000": "50682865778970",
        "5000": "50682865811738",
        "10000": "50726862094618"
      },
      "22oz_Simple": {
        "250": "50665913454538",
        "500": "50682865844506",
        "1000": "50682865877274",
        "2000": "50682865910042",
        "3000": "50682865942810",
        "4000": "50682865975578",
        "5000": "50682866008346"
      },
            "24oz_Simple": {
        "250": "50666591650074",
        "500": "50682866041114",
        "1000": "50682866073882",
        "2000": "50682866106650",
        "3000": "50682866139418",
        "4000": "50682866172186",
        "5000": "50682866204954"
      }
    };

    // DOUBLE WALL (merged from Double Wall product)
    this.variantMappingDouble = {
      "8oz_Simple": {
        "250": "50728921071898",
        "500": "50728921104666",
        "1000": "50686641701146",
        "2000": "50686641733914",
        "3000": "50686641766682",
        "4000": "50686641799450",
        "5000": "50686641832218"
      },
      "8oz_FullColour": {
        "500": "50728921202970",
        "1000": "50686641864986",
        "2000": "50686641897754",
        "3000": "50686641930522",
        "4000": "50686641963290",
        "5000": "50686641996058",
        "10000": "50726860521754"
      },
      "12oz_Simple": {
        "250": "50728921268506",
        "500": "50728921301274",
        "1000": "50686642094362",
        "2000": "50686642127130",
        "3000": "50686642159898",
        "4000": "50686642192666",
        "5000": "50686642225434"
      },
      "12oz_FullColour": {
        "500": "50728921399578",
        "1000": "50686642258202",
        "2000": "50686642290970",
        "3000": "50686642323738",
        "4000": "50686642356506",
        "5000": "50686642389274",
        "10000": "50726860587290"
      },
      "16oz_Simple": {
        "250": "50728921465114",
        "500": "50728921497882",
        "1000": "50686642487578",
        "2000": "50686642520346",
        "3000": "50686642553114",
        "4000": "50686642585882",
        "5000": "50686642618650"
      },
      "16oz_FullColour": {
        "500": "50728921596186",
        "1000": "50686642651418",
        "2000": "50686642684186",
        "3000": "50686642716954",
        "4000": "50686642749722",
        "5000": "50686642782490",
        "10000": "50726860652826"
      }
    };

    // Lid variant mapping - Updated with correct variant IDs from Shopify admin table
    this.lidVariantMapping = {
      "White": {
        "250": "50675484590362",
        "500": "50682897400090",
        "1000": "50682897432858",
        "2000": "50682897465626",
        "3000": "50682897498394",
        "4000": "50682897531162",
        "5000": "50682897563930",
        "10000": "50726870090010"
      },
      "Black": {
        "250": "50675484557594",
        "500": "50682897203482",
        "1000": "50682897236250",
        "2000": "50682897269018",
        "3000": "50682897301786",
        "4000": "50682897334554",
        "5000": "50682897367322",
        "10000": "50726870057242"
      }
    };
      
      this.init().catch(error => console.error('Initialization error:', error));
    }

    async init() {
    this.setupSizeSelector();
    this.setupWallSelector();
    this.setupPrintTypeSelector();
    this.setupLidsSelector();
    this.setupTurnaroundSelector();
    this.setupTooltips();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    this.updatePrintTypeAvailability();
    this.updateWallAvailability();
    this.autoSelectMOQQuantity(); // Auto-select MOQ quantity for initial size/print combination
    await this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }
  
  setupWallSelector() {
    const wallButtons = document.querySelectorAll('.wall-btn');
    if (!wallButtons.length) return;

    wallButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) {
          if (btn.dataset.wall === 'Double') {
            this.showDoubleWallIncompatibilityPopup();
          }
          return;
        }
        wallButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedWall = btn.dataset.wall === 'Double' ? 'Double' : 'Single';

        this.updatePrintTypeAvailability();
        this.updateWallAvailability();
        this.updateDynamicDescription();
        this.autoSelectMOQQuantity();
        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
      });
    });

    // Setup hover popup similar to Full Colour button
    const doubleWallBtn = document.getElementById('double-wall-btn');
    if (doubleWallBtn) {
      doubleWallBtn.addEventListener('mouseenter', () => {
        if (doubleWallBtn.classList.contains('disabled')) {
          this.showDoubleWallIncompatibilityPopup();
        }
      });
      doubleWallBtn.addEventListener('mouseleave', () => {
        this.hideDoubleWallIncompatibilityPopup();
      });
    }
  }

  // Auto-select MOQ quantity based on size and print type
  autoSelectMOQQuantity() {
    const pricingKey = this.getPricingKey();
    const variants = this.getVariantMapping()[pricingKey];
    
    if (!variants) return;
    
    // Get the minimum quantity available for this configuration (which is the MOQ)
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    const moqQuantity = quantities[0]; // First (smallest) quantity is the MOQ
    
    console.log(`Auto-selecting MOQ for ${this.selectedWall} ${pricingKey}: ${moqQuantity}`);
    
    // Update the selected quantity
    this.selectedQuantity = moqQuantity;
  }

  // Initialize 8oz size selection on page load
  initializeSizeSelection() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    
    // Force 8oz selection immediately
    this.force8ozSelection();
    
    // Also force it again after delays to override any other scripts
    setTimeout(() => {
      this.force8ozSelection();
    }, 100);
    
    setTimeout(() => {
      this.force8ozSelection();
    }, 500);
  }

  // Force 8oz size selection
  force8ozSelection() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    
    sizeButtons.forEach(btn => {
      btn.classList.remove('selected');
      
      // Select 8oz button
      if (btn.dataset.size === '8oz') {
        btn.classList.add('selected');
        this.selectedSize = '8oz';
        console.log('Forced 8oz selection');
      }
    });
  }
  
  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);
    
    // Initialize 8oz as selected on page load
    this.initializeSizeSelection();
    
    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log('Size button clicked:', btn.dataset.size);
        
        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);
        
        this.updatePrintTypeAvailability();
        this.updateWallAvailability();
        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when size changes
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }
  
  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);
    
    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) {
          // Show popup if Full Colour is clicked while disabled
          if (btn.dataset.printType === 'FullColour') {
            this.showFullColourIncompatibilityPopup();
          }
          return;
        }
        
        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedPrintType = btn.dataset.printType;
        console.log('Print type selected:', this.selectedPrintType);
        
        // Auto-select MOQ quantity based on new print type
        this.autoSelectMOQQuantity();
        
        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
      });
    });

    // Setup Full Colour incompatibility popup
    this.setupFullColourIncompatibilityPopup();
  }

  setupFullColourIncompatibilityPopup() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    
    if (fullColourBtn) {
      // Show popup on hover when disabled
      fullColourBtn.addEventListener('mouseenter', () => {
        if (fullColourBtn.classList.contains('disabled')) {
          this.showFullColourIncompatibilityPopup();
        }
      });

      // Hide popup when mouse leaves
      fullColourBtn.addEventListener('mouseleave', () => {
        this.hideFullColourIncompatibilityPopup();
      });
    }
  }

  showFullColourIncompatibilityPopup() {
    // Remove any existing popup
    this.hideFullColourIncompatibilityPopup();
    
    // Get the button
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    if (!fullColourBtn) return;
    
    // Get button position relative to viewport
    const rect = fullColourBtn.getBoundingClientRect();
    
    // Create new popup element
    const popup = document.createElement('div');
    popup.id = 'full-colour-incompatible-popup-new';
    popup.innerHTML = 'Only available for 8oz, 12oz and 16oz';
    popup.style.cssText = `
      position: fixed !important;
      top: ${rect.top - 50}px !important;
      left: ${rect.left + rect.width / 2}px !important;
      transform: translateX(-50%) !important;
      background: #dc2626 !important;
      color: white !important;
      padding: 0.75rem 1rem !important;
      border-radius: 8px !important;
      font-size: 0.85rem !important;
      font-weight: 500 !important;
      white-space: nowrap !important;
      opacity: 1 !important;
      visibility: visible !important;
      z-index: 999999 !important;
      box-shadow: 0 8px 16px rgba(220, 38, 38, 0.3) !important;
      pointer-events: none !important;
    `;
    
    // Append to body to avoid opacity inheritance
    document.body.appendChild(popup);
    
    // Auto-hide after 3 seconds
    setTimeout(() => {
      this.hideFullColourIncompatibilityPopup();
    }, 3000);
  }
  
  hideFullColourIncompatibilityPopup() {
    const existingPopup = document.getElementById('full-colour-incompatible-popup-new');
    if (existingPopup) {
      existingPopup.remove();
    }
  }
  
  setupLidsSelector() {
    const lidsPills = document.querySelectorAll('.lids-pill');
    lidsPills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update selection
        lidsPills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');
        
        const lidsValue = pill.dataset.lids;
        this.requireLids = lidsValue !== 'no';
        this.lidColor = lidsValue === 'yes-white' ? 'White' : 'Black';
        
                console.log('Lids selected:', lidsValue, 'requireLids:', this.requireLids, 'lidColor:', this.lidColor);
        
        this.updatePricingTable();
      });
    });
  }
  
  setupTurnaroundSelector() {
    const slider = document.getElementById('production-days-slider');
    const marks = document.querySelectorAll('.production-slider-mark');

    const syncSelection = () => {
      if (!slider) return;

      this.selectedProductionDays = this.getProductionDaysForSliderValue(slider.value);
      this.isRushed = this.getProductionFeePercent() > 0;
      console.log(
        'Production time selected:',
        this.selectedProductionDays,
        'business days',
        'fee:',
        `${this.getProductionFeePercent()}%`
      );

      this.syncProductionTimeUI();
      this.updatePricingTable();
      this.updateShippingCalculator();
    };

    if (slider) {
      slider.addEventListener('input', syncSelection);
      slider.addEventListener('change', syncSelection);

      if (window.setupProductionSliderDemo) {
        window.setupProductionSliderDemo({ slider, onValueChange: syncSelection });
      }
    }

    marks.forEach(mark => {
      mark.addEventListener('click', () => {
        if (!slider) return;
        this.selectedProductionDays = Number(mark.dataset.days) || 10;
        slider.value = this.getSliderValueForProductionDays(this.selectedProductionDays);
        syncSelection();
      });
    });

    this.syncProductionTimeUI();
  }

  setupProductionModeSelector() {
    const modeButtons = document.querySelectorAll('.production-mode-pill');
    if (!modeButtons.length) return;

    const applyMode = (mode) => {
      this.productionInputMode = mode;

      modeButtons.forEach(button => {
        const isSelected = button.dataset.productionMode === mode;
        button.classList.toggle('selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });

      const sliderPanel = document.getElementById('production-slider-panel');
      const plannerPanel = document.getElementById('production-planner-panel');
      if (sliderPanel) {
        const shouldHideSlider = mode !== 'slider';
        sliderPanel.classList.toggle('is-hidden', shouldHideSlider);
        sliderPanel.setAttribute('aria-hidden', String(shouldHideSlider));
      }
      if (plannerPanel) {
        const shouldHidePlanner = mode !== 'planner';
        plannerPanel.classList.toggle('is-hidden', shouldHidePlanner);
        plannerPanel.setAttribute('aria-hidden', String(shouldHidePlanner));
      }

      this.updateShippingCalculator();
    };

    modeButtons.forEach(button => {
      button.addEventListener('click', () => {
        const mode = button.dataset.productionMode === 'planner' ? 'planner' : 'slider';
        applyMode(mode);
      });
    });

    applyMode(this.productionInputMode);
  }

  getSliderValueForProductionDays(days) {
    const index = this.productionDayOptions.indexOf(Number(days));
    return index === -1 ? 0 : index;
  }

  getProductionDaysForSliderValue(value) {
    return this.productionDayOptions[Math.round(Number(value))] ?? 10;
  }

  getProductionFeePercent(days = this.selectedProductionDays) {
    return this.productionFeePercentages[Number(days)] ?? 0;
  }

  getProductionFeeMultiplier() {
    return this.getProductionFeePercent() / 100;
  }

  getProductionTimeLabel(days = this.selectedProductionDays) {
    const normalizedDays = Number(days) || 10;
    const dayCount = Number.isFinite(normalizedDays) ? normalizedDays : 10;
    if (dayCount === 10) {
      return 'Standard (10 business days)';
    }
    return `${dayCount} business day${dayCount === 1 ? '' : 's'}`;
  }

  getProductionFeeLabel(days = this.selectedProductionDays) {
    const feePercent = this.getProductionFeePercent(days);
    return feePercent > 0 ? `+${feePercent}% production fee` : 'No production fee';
  }

  getProductionTimePropertyValue() {
    const feePercent = this.getProductionFeePercent();
    return feePercent > 0
      ? `${this.getProductionTimeLabel()} (+${feePercent}% production fee)`
      : this.getProductionTimeLabel();
  }

  syncProductionTimeUI() {
    const slider = document.getElementById('production-days-slider');
    const daysValue = document.getElementById('production-days-value');
    const feeValue = document.getElementById('production-fee-value');
    const rushLabel = document.getElementById('summary-rush-label');
    const feePercent = this.getProductionFeePercent();

    if (daysValue) {
      daysValue.textContent = this.getProductionTimeLabel();
    }

    if (feeValue) {
      feeValue.textContent = this.getProductionFeeLabel();
    }

    if (rushLabel) {
      rushLabel.textContent = feePercent > 0 ? `Production Fee (+${feePercent}%):` : 'Production Fee:';
    }

    if (slider) {
      const progress = (Number(slider.value) / Number(slider.max || 9)) * 100;
      slider.style.setProperty('--production-progress', `${progress}%`);
    }

    document.querySelectorAll('.production-slider-mark').forEach(mark => {
      mark.classList.toggle('is-active', Number(mark.dataset.days) === Number(this.selectedProductionDays));
    });
  }

  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');
    
    tooltipIcons.forEach(icon => {
      let tooltip = null;
      
      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());
        
        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;
        
        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: '9999',
          opacity: '0',
          visibility: 'hidden',
          transition: 'all 0.2s ease',
          pointerEvents: 'none'
        });
        
        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        container.style.position = 'relative';
        container.appendChild(tooltip);
        
        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';
        
        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;
        
        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;
        
        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;
        
        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }
        
        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }
        
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
        
        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };
      
      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) {
              tooltip.parentNode.removeChild(tooltip);
            }
            tooltip = null;
          }, 200);
        }
      };
      
      // Add event listeners
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
    
    // Clean up tooltips on page interactions
    document.addEventListener('scroll', () => {
      document.querySelectorAll('.tooltip-popup').forEach(t => {
        if (t.parentNode) t.parentNode.removeChild(t);
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.tooltip-icon')) {
        document.querySelectorAll('.tooltip-popup').forEach(t => {
          if (t.parentNode) t.parentNode.removeChild(t);
        });
      }
    });
  }

  setupShippingCalculator() {
    const stateSelect = document.getElementById('delivery-state-select');
    const dateInput = document.getElementById('delivery-date-input');

    this.setupDeliveryDatePicker();

    if (stateSelect) {
      stateSelect.addEventListener('change', () => this.updateShippingCalculator());
    }

    if (dateInput) {
      dateInput.addEventListener('change', () => this.updateShippingCalculator());
    }

    // Initialize the shipping calculator on page load
    this.updateShippingCalculator();
  }

  setupDeliveryDatePicker() {
    const picker = document.getElementById('delivery-date-picker');
    const input = document.getElementById('delivery-date-input');
    const trigger = document.getElementById('delivery-date-trigger');
    const calendar = document.getElementById('delivery-date-calendar');

    if (!picker || !input || !trigger || !calendar) return;

    const getReferenceDate = () => {
      const parsed = this.parseDeliveryDateInput(input.value);
      return parsed || this.getNextSelectableDeliveryDate(new Date());
    };

    this.deliveryDateView = this.getStartOfMonth(getReferenceDate());

    const openCalendar = () => {
      this.deliveryDateView = this.getStartOfMonth(getReferenceDate());
      this.renderDeliveryDateCalendar();
      calendar.classList.remove('is-hidden');
      calendar.setAttribute('aria-hidden', 'false');
      input.setAttribute('aria-expanded', 'true');
    };

    const closeCalendar = () => {
      calendar.classList.add('is-hidden');
      calendar.setAttribute('aria-hidden', 'true');
      input.setAttribute('aria-expanded', 'false');
    };

    input.addEventListener('click', openCalendar);
    input.addEventListener('focus', openCalendar);
    trigger.addEventListener('click', () => {
      if (calendar.classList.contains('is-hidden')) {
        openCalendar();
      } else {
        closeCalendar();
      }
    });

    document.addEventListener('click', (event) => {
      if (!picker.contains(event.target)) {
        closeCalendar();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeCalendar();
      }
    });

    this.deliveryDatePicker = {
      input,
      calendar,
      close: closeCalendar
    };

    this.renderDeliveryDateCalendar();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const stateSelect = document.getElementById('delivery-state-select');
    const dateInput = document.getElementById('delivery-date-input');
    const plannerNoteEl = document.getElementById('delivery-planner-note');
    const plannerResultsEl = document.getElementById('delivery-planner-results');
    const plannerSuggestedTurnaroundEl = document.getElementById('planner-suggested-turnaround');
    const plannerDeliveryMethodEl = document.getElementById('planner-delivery-method');
    const plannerSuggestedFeeEl = document.getElementById('planner-suggested-fee');
    const plannerDispatchDateEl = document.getElementById('planner-dispatch-date');
    const plannerTargetDateEl = document.getElementById('planner-target-date');
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    const selectedState = stateSelect ? String(stateSelect.value || '').trim().toUpperCase() : '';
    const targetDeliveryDateRaw = dateInput ? String(dateInput.value || '').trim() : '';
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    let selectedStateTransitHours = null;

    const plannerModeActive = this.productionInputMode === 'planner';

    if (plannerModeActive && selectedState && targetDeliveryDateRaw) {
      const backwardPlan = this.planDeliveryBackward(currentDate, selectedState, targetDeliveryDateRaw);
      if (backwardPlan) {
        selectedStateTransitHours = backwardPlan.transitHours;

        if (backwardPlan.isAchievable && backwardPlan.recommendedProductionDays !== Number(this.selectedProductionDays)) {
          this.selectedProductionDays = backwardPlan.recommendedProductionDays;
          this.isRushed = this.getProductionFeePercent() > 0;
          this.syncProductionTimeUI();
          this.updatePricingTable();
        }

        if (plannerNoteEl) {
          if (backwardPlan.planType === 'standard') {
            plannerNoteEl.textContent = `We recommend ${this.getProductionTimeLabel(backwardPlan.recommendedProductionDays)} with standard delivery for ${selectedState}.`;
          } else if (backwardPlan.planType === 'express') {
            plannerNoteEl.textContent = `Standard delivery will not make this date for ${selectedState}. We recommend ${this.getProductionTimeLabel(backwardPlan.recommendedProductionDays)} with overnight express.`;
          } else {
            plannerNoteEl.textContent = `This job cannot be accepted for ${selectedState}, even with overnight express. The earliest possible delivery is ${formatDate(backwardPlan.earliestDeliveryDate)}.`;
          }
        }
        if (plannerResultsEl) plannerResultsEl.style.display = '';
        if (plannerSuggestedTurnaroundEl) {
          plannerSuggestedTurnaroundEl.textContent = backwardPlan.isAchievable
            ? this.getProductionTimeLabel(backwardPlan.recommendedProductionDays)
            : 'Job cannot be accepted';
        }
        if (plannerDeliveryMethodEl) plannerDeliveryMethodEl.textContent = backwardPlan.shippingMethodLabel;
        if (plannerSuggestedFeeEl) {
          plannerSuggestedFeeEl.textContent = backwardPlan.isAchievable
            ? this.getProductionFeeLabel(backwardPlan.recommendedProductionDays)
            : 'N/A';
        }
        if (plannerDispatchDateEl) {
          plannerDispatchDateEl.textContent = backwardPlan.isAchievable
            ? formatDate(backwardPlan.dispatchDate)
            : 'N/A';
        }
        if (plannerTargetDateEl) {
          plannerTargetDateEl.textContent = backwardPlan.isAchievable
            ? `${formatDate(backwardPlan.targetDeliveryDate)} (${selectedState})`
            : `${formatDate(backwardPlan.earliestDeliveryDate)} earliest (${selectedState})`;
        }
      }
    } else {
      if (plannerNoteEl) {
        plannerNoteEl.textContent = 'Choose a state and delivery date to get a suggested production time, fee, and dispatch date.';
      }
      if (plannerResultsEl) {
        plannerResultsEl.style.display = 'none';
      }
      if (plannerSuggestedTurnaroundEl) plannerSuggestedTurnaroundEl.textContent = 'Standard (10 business days)';
      if (plannerDeliveryMethodEl) plannerDeliveryMethodEl.textContent = 'Standard delivery';
      if (plannerSuggestedFeeEl) plannerSuggestedFeeEl.textContent = 'No production fee';
    }

    // Determine production days and shipping times based on turnaround selection
    const productionDays = Number(this.selectedProductionDays) || 10;

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    let minDoorstepDate;
    let doorstepDate;

    if (selectedStateTransitHours != null) {
      minDoorstepDate = this.addBusinessHours(shippedDate, selectedStateTransitHours);
      doorstepDate = this.addBusinessDays(minDoorstepDate, 1);
    } else {
      const minDeliveryDays = productionDays + 1;
      const maxDeliveryDays = productionDays + 3;
      minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);
      doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    }

    // Update delivery range with selected production time
    const productionTimeText = this.getProductionTimeLabel();
    
    if (minDoorstepDate.toDateString() === doorstepDate.toDateString()) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  formatDateInputValue(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formatDateDisplayValue(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  getStartOfMonth(date) {
    const value = new Date(date);
    value.setHours(0, 0, 0, 0);
    value.setDate(1);
    return value;
  }

  getNextSelectableDeliveryDate(date) {
    const result = new Date(date);
    result.setHours(0, 0, 0, 0);

    while (this.isWeekend(result)) {
      result.setDate(result.getDate() + 1);
    }

    return result;
  }

  isSelectableDeliveryDate(date) {
    const candidate = new Date(date);
    candidate.setHours(0, 0, 0, 0);
    const earliest = this.getNextSelectableDeliveryDate(new Date());
    return !this.isWeekend(candidate) && candidate >= earliest;
  }

  renderDeliveryDateCalendar() {
    const picker = this.deliveryDatePicker;
    if (!picker || !picker.calendar || !this.deliveryDateView) return;

    const { input, calendar } = picker;
    const selectedDate = this.parseDeliveryDateInput(input.value);
    const currentMonth = new Date(this.deliveryDateView);
    const monthLabel = currentMonth.toLocaleDateString('en-AU', {
      month: 'long',
      year: 'numeric'
    });
    const gridStart = new Date(currentMonth);
    const dayOffset = (gridStart.getDay() + 6) % 7;
    gridStart.setDate(gridStart.getDate() - dayOffset);
    const todayMonth = this.getStartOfMonth(this.getNextSelectableDeliveryDate(new Date()));
    const canGoPrevious = currentMonth > todayMonth;
    const weekdayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    const dayButtons = [];
    for (let index = 0; index < 42; index += 1) {
      const day = new Date(gridStart);
      day.setDate(gridStart.getDate() + index);
      const isCurrentMonth = day.getMonth() === currentMonth.getMonth();
      const isWeekendDay = this.isWeekend(day);
      const isDisabled = !this.isSelectableDeliveryDate(day);
      const isSelected = selectedDate && day.toDateString() === selectedDate.toDateString();
      const classes = [
        'delivery-date-day',
        isCurrentMonth ? '' : 'is-outside-month',
        isWeekendDay ? 'is-weekend' : '',
        isDisabled ? 'is-disabled' : '',
        isSelected ? 'is-selected' : ''
      ].filter(Boolean).join(' ');

      dayButtons.push(`
        <button
          type="button"
          class="${classes}"
          data-date="${this.formatDateInputValue(day)}"
          ${isDisabled ? 'disabled' : ''}
          aria-label="${day.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}"
        >
          ${day.getDate()}
        </button>
      `);
    }

    calendar.innerHTML = `
      <div class="delivery-date-calendar-shell" role="dialog" aria-label="Choose delivery date">
        <div class="delivery-date-calendar-header">
          <button type="button" class="delivery-date-nav" data-calendar-nav="prev" ${canGoPrevious ? '' : 'disabled'} aria-label="Previous month">‹</button>
          <div class="delivery-date-month-label">${monthLabel}</div>
          <button type="button" class="delivery-date-nav" data-calendar-nav="next" aria-label="Next month">›</button>
        </div>
        <div class="delivery-date-weekdays">
          ${weekdayLabels.map(label => `<span>${label}</span>`).join('')}
        </div>
        <div class="delivery-date-days">
          ${dayButtons.join('')}
        </div>
      </div>
    `;

    calendar.querySelector('[data-calendar-nav="prev"]')?.addEventListener('click', () => {
      if (!canGoPrevious) return;
      this.deliveryDateView = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1);
      this.renderDeliveryDateCalendar();
    });

    calendar.querySelector('[data-calendar-nav="next"]')?.addEventListener('click', () => {
      this.deliveryDateView = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
      this.renderDeliveryDateCalendar();
    });

    calendar.querySelectorAll('.delivery-date-day:not(.is-disabled)').forEach(button => {
      button.addEventListener('click', () => {
        const selected = this.parseDeliveryDateInput(button.dataset.date);
        if (!selected) return;
        input.value = this.formatDateDisplayValue(selected);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        picker.close();
      });
    });
  }

  getTransitHoursForState(state) {
    return this.stateTransitHours[state] ?? 72;
  }

  getTransitBusinessDaysForState(state) {
    return this.stateTransitBusinessDays[state] ?? 3;
  }

  subtractBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let remaining = Math.max(0, Number(days) || 0);
    while (remaining > 0) {
      result.setDate(result.getDate() - 1);
      if (!this.isNonBusinessDay(result)) {
        remaining--;
      }
    }
    return result;
  }

  subtractBusinessHours(startDate, hours) {
    const result = new Date(startDate);
    let remaining = Math.max(0, Math.floor(Number(hours) || 0));
    while (remaining > 0) {
      result.setHours(result.getHours() - 1, 0, 0, 0);
      if (!this.isNonBusinessDay(result)) {
        remaining--;
      }
    }
    return result;
  }

  isNonBusinessDay(date) {
    const day = date.getDay();
    if (day === 0 || day === 6) return true;
    try {
      return typeof window.isAustralianHoliday === 'function' ? window.isAustralianHoliday(date) : false;
    } catch (_) {
      return false;
    }
  }

  isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  countBusinessDaysBetween(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    if (end < start) return 0;

    const current = new Date(start);
    let count = 0;

    while (current < end) {
      current.setDate(current.getDate() + 1);
      if (!this.isNonBusinessDay(current) && current <= end) {
        count++;
      }
    }

    return count;
  }

  addWeekdays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      if (!this.isWeekend(result)) {
        addedDays++;
      }
    }

    return result;
  }

  subtractWeekdays(startDate, days) {
    const result = new Date(startDate);
    let remaining = Math.max(0, Number(days) || 0);

    while (remaining > 0) {
      result.setDate(result.getDate() - 1);
      if (!this.isWeekend(result)) {
        remaining--;
      }
    }

    return result;
  }

  countWeekdaysBetween(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    if (end < start) return 0;

    const current = new Date(start);
    let count = 0;

    while (current < end) {
      current.setDate(current.getDate() + 1);
      if (!this.isWeekend(current) && current <= end) {
        count++;
      }
    }

    return count;
  }

  parseDeliveryDateInput(rawValue) {
    const value = String(rawValue || '').trim();
    if (!value) return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const parsedIso = new Date(`${value}T17:00:00`);
      return Number.isNaN(parsedIso.getTime()) ? null : parsedIso;
    }

    const auMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (auMatch) {
      const [, day, month, year] = auMatch;
      const parsedAu = new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T17:00:00`);
      return Number.isNaN(parsedAu.getTime()) ? null : parsedAu;
    }

    const parsedFallback = new Date(value);
    return Number.isNaN(parsedFallback.getTime()) ? null : parsedFallback;
  }

  planDeliveryBackward(orderDate, state, targetDeliveryDateRaw) {
    const parsed = this.parseDeliveryDateInput(targetDeliveryDateRaw);
    if (!parsed || Number.isNaN(parsed.getTime())) return null;

    const targetDeliveryDate = parsed;
    const buildPlan = ({ transitHours, transitBusinessDays, shippingMethodLabel, planType }) => {
      const dispatchDate = this.subtractWeekdays(targetDeliveryDate, transitBusinessDays);
      const availableProductionDays = this.countWeekdaysBetween(orderDate, dispatchDate);
      const recommendedProductionDays = [...this.productionDayOptions]
        .sort((a, b) => b - a)
        .find((days) => days <= availableProductionDays);

      const fastestProductionDays = this.productionDayOptions[this.productionDayOptions.length - 1];
      const earliestDispatchDate = this.addWeekdays(orderDate, fastestProductionDays);
      const earliestDeliveryDate = this.addWeekdays(earliestDispatchDate, transitBusinessDays);

      return {
        orderDate: new Date(orderDate),
        state,
        targetDeliveryDate,
        dispatchDate,
        transitHours,
        transitBusinessDays,
        availableProductionDays,
        recommendedProductionDays: recommendedProductionDays ?? fastestProductionDays,
        isAchievable: Boolean(recommendedProductionDays),
        earliestDeliveryDate,
        shippingMethodLabel,
        planType
      };
    };

    const standardPlan = buildPlan({
      transitHours: this.getTransitHoursForState(state),
      transitBusinessDays: this.getTransitBusinessDaysForState(state),
      shippingMethodLabel: 'Standard delivery',
      planType: 'standard'
    });

    if (standardPlan.isAchievable) {
      return standardPlan;
    }

    const expressPlan = buildPlan({
      transitHours: this.expressTransitHours,
      transitBusinessDays: this.expressTransitBusinessDays,
      shippingMethodLabel: 'Overnight express',
      planType: 'express'
    });

    if (expressPlan.isAchievable) {
      return expressPlan;
    }

    return {
      ...expressPlan,
      shippingMethodLabel: 'Overnight express required',
      planType: 'unavailable',
      recommendedProductionDays: null,
      isAchievable: false
    };
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Initialize with default size (4oz)
    this.updateDynamicDescription();
    
    // Setup accordion dropdown functionality (only one open at a time)
    this.setupAccordionBehavior('.dynamic-description'); // Desktop version
    this.setupAccordionBehavior('.dynamic-description-mobile'); // Mobile version
    
    // Auto-open the first tab (Description) on page load
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopDescriptionTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopDescriptionContent = document.getElementById('description-content');
    
    if (desktopDescriptionTitle && desktopDescriptionContent) {
      desktopDescriptionTitle.classList.add('active');
      desktopDescriptionContent.classList.add('active');
    }
    
    // Open description tab on mobile
    const mobileDescriptionTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileDescriptionContent = document.getElementById('description-content-mobile');
    
    if (mobileDescriptionTitle && mobileDescriptionContent) {
      mobileDescriptionTitle.classList.add('active');
      mobileDescriptionContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    console.log('Setting up accordion behavior for:', containerSelector);
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.log('Container not found:', containerSelector);
      return;
    }
    
    const dropdownTitles = container.querySelectorAll('.dropdown-title');
    console.log('Found dropdown titles:', dropdownTitles.length);
    
    dropdownTitles.forEach((title, index) => {
      console.log(`Styling dropdown title ${index}:`, title.textContent);
      // Force bold styling directly on the element
      title.style.fontWeight = '700';
      title.style.fontWeight = 'bold';
      title.style.setProperty('font-weight', '700', 'important');
      console.log('Applied styles to:', title.textContent, 'font-weight:', title.style.fontWeight);
      
      title.addEventListener('click', (e) => {
        const targetId = title.getAttribute('data-target');
        const content = document.getElementById(targetId);
        
        if (content) {
          const isCurrentlyActive = title.classList.contains('active');
          
          // Close all dropdowns in this container first
          dropdownTitles.forEach(otherTitle => {
            const otherTargetId = otherTitle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);
            
            if (otherContent) {
              otherTitle.classList.remove('active');
              otherContent.classList.remove('active');
            }
          });
          
          // If this wasn't active, open it
          if (!isCurrentlyActive) {
            title.classList.add('active');
            content.classList.add('active');
          }
        }
      });
    });
  }

  updateDynamicDescription() {
    const descriptionData = this.getDescriptionData();
    
    // Update desktop version
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');
    
    // Update mobile version
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');
    
    if (descriptionData) {
      // Update desktop
      if (descriptionContent) {
        descriptionContent.innerHTML = descriptionData.description;
      }
      if (specificationContent) {
        specificationContent.innerHTML = descriptionData.specification;
      }
      if (dielinesContent) {
        dielinesContent.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) {
        howItWorksContent.innerHTML = descriptionData.howItWorks;
      }
      
      // Update mobile (same content)
      if (descriptionContentMobile) {
        descriptionContentMobile.innerHTML = descriptionData.description;
      }
      if (specificationContentMobile) {
        specificationContentMobile.innerHTML = descriptionData.specification;
      }
      if (dielinesContentMobile) {
        dielinesContentMobile.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) {
        howItWorksContentMobile.innerHTML = descriptionData.howItWorks;
      }
    }
  }

  getDescriptionData() {
    const sizeDescriptions = {
      "4oz": {
        description: `
          <p>Our 4oz (110ml) Single Wall Cups are purpose-built for espresso shots, tastings, and small-serve beverages. Compact, lightweight, and fully brandable — they're a favourite for cafés, events, and high-volume promos.</p>
          <p>Available with <strong>Inkjet printing only</strong> — your logo, QR code, or design printed crisp and clean on a premium white background.</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">110ml (4oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Inkjet only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 62mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Carton Dimensions (L x W x H):</span> <span class="spec-value">333mm x 263mm x 358mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">5.5kg</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/4oz_Cup_Template_dec3222c-87bb-429d-a6bb-fa2971a2f391.pdf?v=1762387042" class="download-btn" download="4oz_Cup_Template.pdf" target="_blank">👉 Download 4oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "6oz": {
        description: `
          <p>Our 6oz (220ml) Single Wall Cups are ideal for flat whites, small lattes, and takeaway drinks where size and quality matter. Perfectly sized for cafés, offices, and boutique events, they strike the perfect balance between capacity and convenience.</p>
          <p>Available with <strong>Inkjet printing only</strong> — your logo, QR code, or design printed crisp and clean on a premium white background.</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">220ml (6oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Inkjet only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 80mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Carton Dimensions (L × W × H):</span> <span class="spec-value">414mm × 332mm × 416mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">7.5kg</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/6oz_Cup_Template_1c73e735-0971-49f4-a635-27d1ccc98082.pdf?v=1762387042" class="download-btn" download="6oz_Cup_Template.pdf" target="_blank">👉 Download 6oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
         `
       },
       "8oz": {
         description: `
           <p>Our 8oz (250ml) Single Wall Cups are a crowd favourite for regular coffee serves — ideal for lattes, cappuccinos, and iced drinks. Durable, brandable, and made for everyday service, they're perfect for cafés, pop-ups, corporate events, and retail.</p>
           <p><strong>Available in Inkjet or Laser printing:</strong></p>
           <p>• <strong>Inkjet:</strong> vibrant prints on a premium white background (MOQ 250 units)<br>
           • <strong>Laser:</strong> high-definition full-wrap designs (MOQ 1,000 units)</p>
         `,
         specification: `
           <ul>
             <li><span class="spec-label">Capacity:</span> <span class="spec-value">250ml (8oz)</span></li>
             <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
             <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
             <li><span class="spec-label">Print Type:</span> <span class="spec-value">Inkjet or Laser</span></li>
             <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Inkjet) / 1,000 units (Laser)</span></li>
             <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 80mm PE lids (black or white)</span></li>
             <li><span class="spec-label">Carton Dimensions (L × W × H):</span> <span class="spec-value">413mm × 333mm × 558mm</span></li>
             <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">8.9kg</span></li>
           </ul>
         `,
         dielines: `
           <p>Download the template and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8ozA_Cup_Template_cfb40b78-835b-4a1d-9903-0b0b1fbe0aad.pdf?v=1762387042" class="download-btn" download="8ozA_Cup_Template.pdf" target="_blank">👉 Download 8oz Template</a>
           <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
         `,
         howItWorks: `
           <div class="process-timeline">
             <div class="process-step">
               <div class="process-number">1</div>
               <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
             </div>
             <div class="process-step">
               <div class="process-number">2</div>
               <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
             </div>
             <div class="process-step">
               <div class="process-number">3</div>
               <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       },
       "12oz": {
         description: `
           <p>Our 12oz (395ml) Single Wall Cups are the perfect middle ground — ideal for regular coffee, tea, and iced drinks. Sturdy, versatile, and built for branding, they're a staple for cafés, food trucks, corporate events, and venues wanting reliable takeaway options.</p>
           <p><strong>Available in Inkjet or Laser printing:</strong></p>
           <p>• <strong>Inkjet:</strong> vibrant prints on a clean white background (MOQ 250 units)<br>
           • <strong>Laser:</strong> full-wrap high-definition designs (MOQ 1,000 units)</p>
         `,
         specification: `
           <ul>
             <li><span class="spec-label">Capacity:</span> <span class="spec-value">395ml (12oz)</span></li>
             <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
             <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
             <li><span class="spec-label">Print Type:</span> <span class="spec-value">Inkjet or Laser</span></li>
             <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Inkjet) / 1,000 units (Laser)</span></li>
             <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm PE lids (black or white)</span></li>
             <li><span class="spec-label">Carton Dimensions (L × W × H):</span> <span class="spec-value">496mm × 333mm × 558mm</span></li>
             <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">11.3kg</span></li>
           </ul>
         `,
         dielines: `
           <p>Download the appropriate dieline template to apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/12ozXL_Cup_Template_c505dcd4-b799-4a04-8198-a09eb49137f9.pdf?v=1762387042" class="download-btn" download="12ozXL_Cup_Template.pdf" target="_blank">👉 Download 12oz Template</a>
           <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
         `,
         howItWorks: `
           <div class="process-timeline">
             <div class="process-step">
               <div class="process-number">1</div>
               <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
             </div>
             <div class="process-step">
               <div class="process-number">2</div>
               <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
             </div>
             <div class="process-step">
               <div class="process-number">3</div>
               <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       },
       "16oz": {
         description: `
           <p>Our 16oz (480ml) Single Wall Cups are made for larger serves — perfect for long blacks, lattes, iced drinks, and even cocktails. Durable, recyclable, and fully customisable, these cups are built for busy cafés, events, and takeaway venues needing serious capacity and standout branding.</p>
           <p><strong>Available in Inkjet or Laser printing:</strong></p>
           <p>• <strong>Inkjet:</strong> white background, vibrant logo/detail prints (MOQ 250 units)<br>
           • <strong>Laser:</strong> full-colour, edge-to-edge designs (MOQ 1,000 units)</p>
         `,
         specification: `
           <ul>
             <li><span class="spec-label">Capacity:</span> <span class="spec-value">480ml (16oz)</span></li>
             <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
             <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
             <li><span class="spec-label">Print Type:</span> <span class="spec-value">Inkjet or Laser</span></li>
             <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Inkjet) / 1,000 units (Laser)</span></li>
             <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm PE lids (black or white)</span></li>
             <li><span class="spec-label">Carton Dimensions (L × W × H):</span> <span class="spec-value">496mm × 333mm × 558mm</span></li>
             <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">13kg</span></li>
           </ul>
         `,
         dielines: `
           <p>Download your dieline to ensure perfect print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/16oz_Cup_Template_5d34a8ce-aeed-44d5-94b7-c11b8cc00656.pdf?v=1762387042" class="download-btn" download="16oz_Cup_Template.pdf" target="_blank">👉 Download 16oz Template</a>
           <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
         `,
         howItWorks: `
           <div class="process-timeline">
             <div class="process-step">
               <div class="process-number">1</div>
               <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
             </div>
             <div class="process-step">
               <div class="process-number">2</div>
               <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
             </div>
             <div class="process-step">
               <div class="process-number">3</div>
               <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       },
       "22oz": {
         description: `
           <p>Our 22oz (610ml) Single Wall Cups are built for big servings — ideal for cold drinks, iced coffees, smoothies, or event beverages. With a crisp white base and sharp Inkjet printing, they're perfect for impactful branding at festivals, venues, and high-traffic promos.</p>
           <p>Available with <strong>Inkjet printing only</strong> — clean, bold logo or design prints on a premium white background.</p>
           <p><strong>Minimum order: 250 units.</strong></p>
         `,
         specification: `
           <ul>
             <li><span class="spec-label">Capacity:</span> <span class="spec-value">610ml (22oz)</span></li>
             <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
             <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
             <li><span class="spec-label">Print Type:</span> <span class="spec-value">Inkjet only</span></li>
             <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
             <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm PE lids (black or white)</span></li>
             <li><span class="spec-label">Carton Dimensions:</span> <span class="spec-value">TBC</span></li>
             <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">TBC</span></li>
           </ul>
         `,
                  dielines: `
            <p>Ensure perfect print placement — download the dieline below:</p>
            <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/22oz_Cup_Template_bbce4521-f3c9-4f92-9c3b-aa99cf3594e3.pdf?v=1762387042" class="download-btn" download="22oz_Cup_Template.pdf" target="_blank">👉 Download 22oz Template</a>
            <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with dielines or bulk box specs? Just reach out.</p>
          `,
         howItWorks: `
           <div class="process-timeline">
             <div class="process-step">
               <div class="process-number">1</div>
               <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
             </div>
             <div class="process-step">
               <div class="process-number">2</div>
               <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
             </div>
             <div class="process-step">
               <div class="process-number">3</div>
               <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       },
       "24oz": {
         description: `
           <p>Go big with our 24oz (730ml) Single Wall Cups — perfect for extra-large drinks, venue service, or standout promotional moments. Lightweight, recyclable, and designed for crisp full-brand visuals using our Inkjet print method.</p>
           <p>Available with <strong>Inkjet printing only</strong> — perfect for clean white backgrounds and sharp logo placement.</p>
           <p><strong>Minimum order: 250 units.</strong></p>
         `,
         specification: `
           <ul>
             <li><span class="spec-label">Capacity:</span> <span class="spec-value">730ml (24oz)</span></li>
             <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
             <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
             <li><span class="spec-label">Print Type:</span> <span class="spec-value">Inkjet only</span></li>
             <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
             <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm PE lids (black or white)</span></li>
             <li><span class="spec-label">Carton Dimensions:</span> <span class="spec-value">TBC</span></li>
             <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">TBC</span></li>
           </ul>
         `,
                  dielines: `
            <p>Download the dieline to place your artwork correctly:</p>
            <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/24oz_Cup_Template_52348637-3c54-4999-beac-c0c96d9f96cc.pdf?v=1762387042" class="download-btn" download="24oz_Cup_Template.pdf" target="_blank">👉 Download 24oz Template</a>
            <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need layout support or bulk specs? We're always happy to help.</p>
          `,
         howItWorks: `
           <div class="process-timeline">
             <div class="process-step">
               <div class="process-number">1</div>
               <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
             </div>
             <div class="process-step">
               <div class="process-number">2</div>
               <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
             </div>
             <div class="process-step">
               <div class="process-number">3</div>
               <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       }
       // More sizes will be added here
    };
    
    // Provide Double Wall descriptions for 8/12/16 when selected
    const sizeDescriptionsDouble = {
      "8oz": {
        description: `
          <p>Our 8oz (250ml) Double Wall Cups provide superior heat insulation for hot beverages — perfect for lattes, cappuccinos, and specialty drinks. The double-wall construction eliminates the need for sleeves while providing comfortable handling and professional presentation.</p>
          <p><strong>Available in Simple or Full Colour printing:</strong></p>
          <p>• <strong>Simple:</strong> clean logo and text prints on premium white background (MOQ 250 units)<br>
          • <strong>Full Colour:</strong> vibrant, full-wrap designs with unlimited colours (MOQ 500 units)</p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">250ml (8oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified double wall paperboard</span></li>
            <li><span class="spec-label">Insulation:</span> <span class="spec-value">Air-gap double wall construction</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 500 units (Full Colour)</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 80mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Carton Dimensions (L × W × H):</span> <span class="spec-value">413mm × 333mm × 558mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">12.5kg</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the template and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8ozA_Double_Wall_Cup_Template_ea30899c-7167-40f1-964e-4b68d177f846.pdf?v=1762386998" class="download-btn" download="8ozA_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 8oz Double Wall Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom double wall cups go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "12oz": {
        description: `
          <p>Our 12oz (395ml) Double Wall Cups are the perfect middle ground for premium hot beverages. The double-wall insulation provides superior heat retention and comfortable handling without sleeves — ideal for specialty coffee shops, corporate events, and premium service venues.</p>
          <p><strong>Available in Simple or Full Colour printing:</strong></p>
          <p>• <strong>Simple:</strong> professional logos and branding on premium white backgrounds (MOQ 250 units)<br>
          • <strong>Full Colour:</strong> high-impact, full-wrap designs with unlimited colours (MOQ 500 units)</p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">395ml (12oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified double wall paperboard</span></li>
            <li><span class="spec-label">Insulation:</span> <span class="spec-value">Air-gap double wall construction</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 500 units (Full Colour)</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Carton Dimensions (L × W × H):</span> <span class="spec-value">496mm × 333mm × 558mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">15.2kg</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the appropriate dieline template to apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/12ozXL_Double_Wall_Cup_Template_5489dcae-8e3f-4cd8-819f-5cdc549b2ae2.pdf?v=1762386998" class="download-btn" download="12ozXL_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 12oz Double Wall Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom double wall cups go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "16oz": {
        description: `
          <p>Our 16oz (480ml) Double Wall Cups are designed for large hot beverages and extended drinking sessions. Superior insulation keeps drinks hot longer while the double-wall construction provides comfortable handling without sleeves — perfect for busy cafés, events, and venues serving premium large serves.</p>
          <p><strong>Available in Simple or Full Colour printing:</strong></p>
          <p>• <strong>Simple:</strong> bold logos and branding on premium backgrounds (MOQ 250 units)<br>
          • <strong>Full Colour:</strong> stunning full-wrap designs with unlimited colours and gradients (MOQ 500 units)</p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">480ml (16oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified double wall paperboard</span></li>
            <li><span class="spec-label">Insulation:</span> <span class="spec-value">Air-gap double wall construction</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 500 units (Full Colour)</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Carton Dimensions (L × W × H):</span> <span class="spec-value">496mm × 333mm × 558mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">17.8kg</span></li>
          </ul>
        `,
        dielines: `
          <p>Download your dieline to ensure perfect print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/16oz_Double_Wall_Cup_Template_045d62b5-215e-4b46-9715-0ffd0685cc4b.pdf?v=1762386998" class="download-btn" download="16oz_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 16oz Double Wall Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom double wall cups go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      }
    };

    const map = this.selectedWall === 'Double' ? sizeDescriptionsDouble : sizeDescriptions;
    return map[this.selectedSize] || map[this.selectedWall === 'Double' ? '8oz' : '4oz'];
  }
  
  setupFormSubmission() {
    const customButton = document.getElementById('custom-add-to-cart-btn');
    if (customButton) {
      customButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }
  
  setupFileUpload() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('div[id^="fileInfo-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');
    const removeButton = document.querySelector('button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
        
        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  clearFileSelection() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    console.log('File selection cleared');
  }
  
  updatePrintTypeAvailability() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    const unavailableIndicator = fullColourBtn?.querySelector('.unavailable-indicator');
    
    if (fullColourBtn && unavailableIndicator) {
      const isAvailable = this.fullColourSizes.includes(this.selectedSize);
      
      if (isAvailable) {
        fullColourBtn.classList.remove('disabled');
        unavailableIndicator.style.display = 'none';
      } else {
        fullColourBtn.classList.add('disabled');
        unavailableIndicator.style.display = 'inline';
        
        // Switch to Simple Print if Full Colour was selected
        if (this.selectedPrintType === 'FullColour') {
          const simplePrintBtn = document.getElementById('simple-print-btn');
          if (simplePrintBtn) {
            simplePrintBtn.click();
    }
        }
      }
    }
  }

  updateWallAvailability() {
    const doubleWallBtn = document.getElementById('double-wall-btn');
    const unavailableIndicator = doubleWallBtn?.querySelector('.unavailable-indicator');
    if (doubleWallBtn && unavailableIndicator) {
      const isAvailable = this.doubleWallSizes.includes(this.selectedSize);
      if (isAvailable) {
        doubleWallBtn.classList.remove('disabled');
        unavailableIndicator.style.display = 'none';
      } else {
        doubleWallBtn.classList.add('disabled');
        unavailableIndicator.style.display = 'inline';
        if (this.selectedWall === 'Double') {
          const singleBtn = document.querySelector('.wall-btn[data-wall="Single"]');
          if (singleBtn) {
            singleBtn.click();
          }
        }
      }
    }
  }

  showDoubleWallIncompatibilityPopup() {
    // Remove any existing popup
    this.hideDoubleWallIncompatibilityPopup();
    const btn = document.getElementById('double-wall-btn');
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    const popup = document.createElement('div');
    popup.id = 'double-wall-incompatible-popup-new';
    popup.innerHTML = 'Only available for 8oz, 12oz and 16oz';
    popup.style.cssText = `
      position: fixed !important;
      top: ${rect.top - 50}px !important;
      left: ${rect.left + rect.width / 2}px !important;
      transform: translateX(-50%) !important;
      background: #dc2626 !important;
      color: white !important;
      padding: 0.75rem 1rem !important;
      border-radius: 8px !important;
      font-size: 0.85rem !important;
      font-weight: 500 !important;
      white-space: nowrap !important;
      opacity: 1 !important;
      visibility: visible !important;
      z-index: 999999 !important;
      box-shadow: 0 8px 16px rgba(220, 38, 38, 0.3) !important;
      pointer-events: none !important;
    `;
    document.body.appendChild(popup);
    setTimeout(() => {
      this.hideDoubleWallIncompatibilityPopup();
    }, 3000);
  }

  hideDoubleWallIncompatibilityPopup() {
    const existing = document.getElementById('double-wall-incompatible-popup-new');
    if (existing) existing.remove();
  }
  
  getPricingKey() {
    const printType = this.selectedPrintType === 'FullColour' ? 'FullColour' : 'Simple';
    return `${this.selectedSize}_${printType}`;
  }
  
  getVariantMapping() {
    return this.selectedWall === 'Double' ? this.variantMappingDouble : this.variantMappingSingle;
  }

  // Robust fetch of variant price in dollars by ID
  async fetchVariantPriceDollars(variantId) {
    const endpoints = [
      `/variants/${variantId}.json`,
      `/variants/${variantId}.js`
    ];
    for (const url of endpoints) {
      try {
        const res = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json,text/plain,*/*' } });
        if (!res.ok) continue;
        let data;
        try { data = await res.clone().json(); }
        catch(_) {
          const txt = await res.text();
          try { data = JSON.parse(txt); }
          catch(_) {
            const m = /"price"\s*:\s*"?([0-9]+(?:\.[0-9]+)?)"?/i.exec(txt);
            if (m) {
              const num = parseFloat(m[1]);
              if (isFinite(num)) return num;
            }
            continue;
          }
        }
        const v = data?.variant || data;
        if (!v) continue;
        let p = v.price;
        p = typeof p === 'string' ? parseFloat(p) : Number(p);
        if (!isFinite(p)) continue;
        if (p > 100 && Number.isInteger(p)) p = p / 100;
        return p;
      } catch(_) {}
    }
    return null;
  }

  async fetchVariantPricesBatch(variantIds) {
    const unique = [...new Set((variantIds || []).filter(Boolean))];
    const missing = unique.filter(id => !this.variantPriceCache.has(id));
    await Promise.all(missing.map(async (id) => {
      const p = await this.fetchVariantPriceDollars(id);
      if (p != null) this.variantPriceCache.set(id, p);
    }));
  }
  
  getUnitsPerCarton() {
    return this.selectedWall === 'Double' ? this.UNITS_PER_CARTON_DOUBLE : this.UNITS_PER_CARTON_SINGLE;
  }

  // Helper function to get the appropriate lid quantity based on cup quantity
  getLidQuantityTier(cupQuantity) {
    // Map cup quantities to lid variant quantities
    if (cupQuantity <= 250) return "250";
    if (cupQuantity <= 500) return "500"; 
    if (cupQuantity <= 1000) return "1000";
    if (cupQuantity <= 2000) return "2000";
    if (cupQuantity <= 3000) return "3000";
    if (cupQuantity <= 4000) return "4000";
    if (cupQuantity <= 5000) return "5000";
    if (cupQuantity >= 10000) return "10000";
    return "5000"; // Default fallback
    }

    async loadProductData() {
    if (this.productData) return this.productData;
    
    try {
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (productScript) {
        this.productData = JSON.parse(productScript.textContent);
        console.log('Loaded product data from script:', this.productData.handle);
        return this.productData;
      }
      
      // Fallback: fetch from API using product handle from URL
      const pathParts = window.location.pathname.split('/');
      const handle = pathParts[pathParts.indexOf('products') + 1];
      
      if (handle) {
        const response = await fetch(`/products/${handle}.js`);
        this.productData = await response.json();
        console.log('Loaded product data from API:', this.productData.handle);
        return this.productData;
      }
      
      throw new Error('Could not determine product handle');
    } catch (error) {
      console.error('Failed to load product data:', error);
      return null;
    }
  }

  async updatePricingTable() {
    console.log('[Debug] updatePricingTable called');
    const formEl = document.querySelector('#product-form-cup');
    const tbody = formEl ? formEl.querySelector('#quantity-grid-body') : document.getElementById('quantity-grid-body');
    if (!tbody) {
      console.error('[Debug] quantity-grid-body element not found!');
      return;
    }

    // Prevent duplicate renders from overlapping async calls
    this._pricingRenderCounter = (this._pricingRenderCounter || 0) + 1;
    const renderId = this._pricingRenderCounter;

    const pricingKey = this.getPricingKey();
    const mapping = this.getVariantMapping();
    const variants = mapping[pricingKey];
    
    console.log('[Debug] Updating pricing for:', this.selectedWall, pricingKey, variants);
    console.log('[Debug] Current state - Size:', this.selectedSize, 'PrintType:', this.selectedPrintType);
    
    // Debug membership pricing
    console.log('[Debug] MembershipPricing available:', !!window.MembershipPricing);
    if (window.MembershipPricing) {
      console.log('[Debug] Customer tier:', window.MembershipPricing.getCustomerTier());
      console.log('[Debug] Discount percent:', window.MembershipPricing.getDiscountPercent());
    }
    
    if (!variants) {
      if (renderId !== this._pricingRenderCounter) return;
      console.error('[Debug] No variants found for pricing key:', pricingKey);
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }
    
    // Load product data for price lookup (but don't require it)
    console.log('[Debug] Loading product data...');
    await this.loadProductData();
    console.log('[Debug] Product data loaded:', !!this.productData);
    
    const frag = document.createDocumentFragment();

    // Get available quantities for this configuration and prefetch live prices
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    await this.fetchVariantPricesBatch(Object.values(variants));
    console.log('[Debug] Available quantities:', quantities);
    
    for (let i = 0; i < quantities.length; i++) {
      const qty = quantities[i];
      const variantId = variants[qty.toString()];
      
      // Try to find variant in product data
      let variant = null;
      let variantPrice = 0;
      let unitPrice = 0;
      
      if (this.productData) {
        variant = this.productData.variants.find(v => v.id == variantId);
      }
      
      console.log(`[Pricing Debug] ${pricingKey} - Qty: ${qty}, VariantID: ${variantId}, Found: ${!!variant}`);
      
      if (variant) {
        // Use live Shopify pricing
        if (typeof variant.price === 'string') {
          variantPrice = parseFloat(variant.price);
        } else {
          // Assume cents, convert to dollars
          variantPrice = variant.price / 100;
        }
        unitPrice = variantPrice / qty;
      } else {
        // Try cached or live fetch by ID first
        const cached = this.variantPriceCache.get(variantId);
        const live = cached != null ? cached : await this.fetchVariantPriceDollars(variantId);
        if (live != null) {
          variantPrice = live;
          unitPrice = live / qty;
          if (cached == null) this.variantPriceCache.set(variantId, live);
        } else {
          // Fallback tiers
          console.warn(`Using fallback pricing for ${pricingKey} ${qty} units (variant ${variantId} not found)`);
          if (qty >= 5000) unitPrice = 0.25;
          else if (qty >= 4000) unitPrice = 0.28;
          else if (qty >= 3000) unitPrice = 0.32;
          else if (qty >= 2000) unitPrice = 0.38;
          else if (qty >= 1000) unitPrice = 0.45;
          else if (qty >= 500) unitPrice = 0.55;
          else unitPrice = 0.75;
          if (pricingKey.includes('22oz') || pricingKey.includes('24oz')) unitPrice *= 2.5;
          else if (pricingKey.includes('16oz')) unitPrice *= 1.8;
          else if (pricingKey.includes('12oz')) unitPrice *= 1.4;
          else if (pricingKey.includes('8oz')) unitPrice *= 1.2;
          if (pricingKey.includes('FullColour')) unitPrice *= 1.25;
          variantPrice = unitPrice * qty;
        }
      }
      
      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = qty;
      
      // Make entire row clickable
      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Radio button
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'quantity_selection';
      radio.value = qty;
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Pre-select first option or maintain current selection
      if ((i === 0 && this.selectedQuantity === null) || qty === this.selectedQuantity) {
        radio.checked = true;
        this.selectedQuantity = qty;
        this.currentUnitPrice = unitPrice;
        row.classList.add('selected');
      }
      
      radioCell.appendChild(radio);
      row.appendChild(radioCell);
        
      // Quantity
      const qtyCell = document.createElement('td');
      qtyCell.textContent = qty.toLocaleString();
      row.appendChild(qtyCell);

      // Cartons
      const cartonsCell = document.createElement('td');
      const cartons = qty / this.getUnitsPerCarton();
      cartonsCell.textContent = this.decimalToFraction(cartons);
      row.appendChild(cartonsCell);

      // Unit Price (with membership pricing)
      const unitPriceCell = document.createElement('td');
      
      // Check if customer has membership tags directly from body data attribute
      const customerTags = document.body.dataset.customerTags || '';
      const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
      // Use centralized membership pricing system
      let memberTier = null;
      let discountPercent = 0;
      
      if (window.MembershipPricing) {
        memberTier = window.MembershipPricing.getCustomerTier();
        discountPercent = window.MembershipPricing.getDiscountPercent();
      } else {
        // Fallback to legacy logic for bronze/silver/gold/trade
        if (tags.includes('trade')) {
          memberTier = 'trade';
          discountPercent = 20;
        } else if (tags.includes('gold')) {
          memberTier = 'gold';
          discountPercent = 15;
        } else if (tags.includes('silver')) {
          memberTier = 'silver';
          discountPercent = 10;
        } else if (tags.includes('bronze')) {
          memberTier = 'bronze';
          discountPercent = 5;
        }
      }
      
      if (memberTier && discountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Unit Price - Original: $${unitPrice.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);
        
        unitPriceCell.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
        `;
      } else {
        unitPriceCell.textContent = `$${unitPrice.toFixed(2)}`;
      }
      row.appendChild(unitPriceCell);

      // Total Price (with membership pricing)
      const totalCell = document.createElement('td');
      
      if (memberTier && discountPercent > 0) {
        const discountedTotal = variantPrice * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Total Price - Original: $${variantPrice.toFixed(2)}, Discounted: $${discountedTotal.toFixed(2)}, Tier: ${memberTier}`);
        
        totalCell.innerHTML = `
          <span class="original-price">$${variantPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        totalCell.textContent = `$${variantPrice.toFixed(2)}`;
      }
      row.appendChild(totalCell);

      frag.appendChild(row);
      console.log(`[Debug] Row created for quantity ${qty}`);
    }
    // Drop stale renders if a newer one started while building
    if (renderId !== this._pricingRenderCounter) return;
    tbody.innerHTML = '';
    tbody.appendChild(frag);

    console.log(`[Debug] Total rows created: ${quantities.length}`);
    console.log(`[Debug] tbody children count: ${tbody.children.length}`);

    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    this.updateOrderSummary();
  }

  calculateUnitPrice() {
    // Return the cached unit price from live data
    return this.currentUnitPrice || 0;
  }

  // Helper method to calculate variant total price
  calculateVariantTotalPrice() {
    // Calculate total price from live variant data
    const unitPrice = this.calculateUnitPrice();
    const totalPrice = unitPrice * this.selectedQuantity;
    
    console.log(`[VariantTotalPrice] Unit: $${unitPrice}, Qty: ${this.selectedQuantity}, Total: $${totalPrice}`);
    
    return totalPrice;
  }

  // Smart number formatting - only show decimals if needed, max 2 decimals
  formatNumber(number) {
    const rounded = Math.round(number * 100) / 100; // Round to 2 decimal places
    return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(2);
  }

  updateRowSelection() {
    // Remove selection from all rows
    document.querySelectorAll('.quantity-row').forEach(row => {
      row.classList.remove('selected');
    });
    
    // Add selection to current row
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) {
        selectedRow.classList.add('selected');
      }
    }
  }
  
  updateSelectedQuantityDisplay() {
    // Update any selected quantity display elements
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });
    
    // Update order summary
    this.updateOrderSummary();
  }
  
  updateOrderSummary() {
    if (!this.selectedQuantity) return;
    
    // Get current pricing for display calculations
    const pricingKey = this.getPricingKey();
    const mapping = this.getVariantMapping();
    const variants = mapping[pricingKey];
    const variant = variants[this.selectedQuantity.toString()];
    
    if (!variant) {
      console.warn(`Variant not found for quantity: ${this.selectedQuantity}`);
      return;
    }
    
    // Get membership info for all calculations
    const customerTags = document.body.dataset.customerTags || '';
    const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
    // Use centralized membership pricing system
    let memberTier = null;
    let memberDiscountPercent = 0;
    
    if (window.MembershipPricing) {
      memberTier = window.MembershipPricing.getCustomerTier();
      memberDiscountPercent = window.MembershipPricing.getDiscountPercent();
    } else {
              // Fallback to legacy logic for bronze/silver/gold/trade
        if (tags.includes('trade')) {
          memberTier = 'trade';
          memberDiscountPercent = 20;
      } else if (tags.includes('gold')) {
        memberTier = 'gold';
        memberDiscountPercent = 15;
      } else if (tags.includes('silver')) {
        memberTier = 'silver';
        memberDiscountPercent = 10;
      } else if (tags.includes('bronze')) {
        memberTier = 'bronze';
        memberDiscountPercent = 5;
      }
    }
    
    let unitPrice = this.calculateUnitPrice();
    let lidPrice = 0;
    let rushFee = 0;
    // Calculate cup total and apply member discount
    let cupTotal = this.selectedQuantity * unitPrice;
    
    // Apply member discount to cup total
    if (memberDiscountPercent > 0) {
      cupTotal = cupTotal * (1 - memberDiscountPercent / 100);
      console.log(`[Cup Debug] Member discount applied to cup total: ${memberDiscountPercent}% off`);
    }
    
    let totalPrice = cupTotal;

    // Add lids cost (with member discount applied)
    if (this.requireLids) {
      // Calculate separate lid pricing for all quantities
      const lidUnitPrice = this.selectedQuantity >= 1000 ? this.LID_PRICE_HIGH_QTY : this.LID_PRICE_LOW_QTY;
      lidPrice = this.selectedQuantity * lidUnitPrice;
      
      // Apply member discount to lid price
      if (memberDiscountPercent > 0) {
        lidPrice = lidPrice * (1 - memberDiscountPercent / 100);
        console.log(`[Lid Debug] Member discount applied to lid price: ${memberDiscountPercent}% off`);
      }
      
      totalPrice += lidPrice;
      unitPrice += lidUnitPrice; // Keep unit price calculation for display consistency
      document.getElementById('summary-lid-row').style.display = '';
      
      // Display lid price with original/discounted format for members
      if (memberDiscountPercent > 0) {
        const originalLidPrice = this.selectedQuantity * lidUnitPrice;
        document.getElementById('summary-lid-price').innerHTML = `
          <span class="original-price">$${originalLidPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${lidPrice.toFixed(2)}</span>
        `;
      } else {
        document.getElementById('summary-lid-price').textContent = `$${lidPrice.toFixed(2)}`;
      }
    } else {
      document.getElementById('summary-lid-row').style.display = 'none';
      document.getElementById('summary-lid-price').textContent = '$0.00';
    }

    // Add rush surcharge (for display purposes) - Rush fee should be calculated on discounted price
    const productionFeePercent = this.getProductionFeePercent();
    const productionFeeMultiplier = this.getProductionFeeMultiplier();

    if (productionFeePercent > 0) {
      // Calculate rush fee based on the discounted cup total for members
      let baseCupTotal = this.selectedQuantity * this.calculateUnitPrice();
      
      // Apply member discount to the base total before calculating rush fee
      if (memberDiscountPercent > 0) {
        baseCupTotal = baseCupTotal * (1 - memberDiscountPercent / 100);
        console.log(`[Rush Debug] Member discount applied to rush calculation: ${memberDiscountPercent}% off`);
        // Don't round rush fee for members since discount is applied at product level
        rushFee = baseCupTotal * productionFeeMultiplier;
      } else {
        // Keep rounding for non-members
        rushFee = Math.round(baseCupTotal * productionFeeMultiplier);
      }
      totalPrice += rushFee;
      
      console.log(`[Rush Debug] Rush fee calculated: Base: $${baseCupTotal.toFixed(2)} -> Rush: $${rushFee.toFixed(2)}`);
      
      document.getElementById('summary-rush-row').style.display = '';
      
      // Display rush fee with original/discounted format for members
      if (memberDiscountPercent > 0) {
        const originalCupTotal = this.selectedQuantity * this.calculateUnitPrice();
        const originalRushFee = Math.round(originalCupTotal * productionFeeMultiplier);
        document.getElementById('summary-rush-fee').innerHTML = `
          <span class="original-price">$${originalRushFee.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${rushFee.toFixed(2)}</span>
        `;
      } else {
        document.getElementById('summary-rush-fee').textContent = `$${rushFee.toFixed(2)}`;
      }
    } else {
      document.getElementById('summary-rush-row').style.display = 'none';
      document.getElementById('summary-rush-fee').textContent = '$0.00';
    }

    // Update summary elements (with membership pricing)
    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');
    
    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();
    
    if (summaryUnitPrice) {
      if (memberTier && memberDiscountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - memberDiscountPercent / 100);
        console.log(`[Membership Debug] Summary Unit Price - Original: $${unitPrice.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);
        summaryUnitPrice.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
        `;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(2)}`;
      }
    }
    
    if (summaryTotal) {
      if (memberTier && memberDiscountPercent > 0) {
        // For members: Calculate original totals to show accurate total savings
        const originalCupTotal = this.selectedQuantity * this.calculateUnitPrice();
        const originalLidPrice = this.requireLids ? this.selectedQuantity * (this.selectedQuantity >= 1000 ? this.LID_PRICE_HIGH_QTY : this.LID_PRICE_LOW_QTY) : 0;
        const originalRushFee = productionFeePercent > 0 ? Math.round(originalCupTotal * productionFeeMultiplier) : 0;
        const originalSubtotal = originalCupTotal + originalLidPrice + originalRushFee;
        
        // Calculate individual savings breakdown for accurate total
        const cupSavings = originalCupTotal * (memberDiscountPercent / 100);
        const lidSavings = originalLidPrice * (memberDiscountPercent / 100);
        const rushFeeSavings = originalRushFee - rushFee; // Difference between original and discounted rush fee
        const totalSavings = cupSavings + lidSavings + rushFeeSavings;
        
        console.log(`[Membership Debug] Savings Breakdown:`);
        console.log(`- Cup Savings (${memberDiscountPercent}%): $${cupSavings.toFixed(2)}`);
        console.log(`- Lid Savings (${memberDiscountPercent}%): $${lidSavings.toFixed(2)}`);
        console.log(`- Rush Fee Savings: $${rushFeeSavings.toFixed(2)}`);
        console.log(`- Total Member Savings: $${totalSavings.toFixed(2)}`);
        console.log(`- Original Subtotal: $${originalSubtotal.toFixed(2)}`);
        console.log(`- Final Total: $${totalPrice.toFixed(2)}`);
        console.log(`- Verification: ${originalSubtotal.toFixed(2)} - ${totalSavings.toFixed(2)} = ${(originalSubtotal - totalSavings).toFixed(2)}`);
        
        // Display final total with original subtotal crossed out
        summaryTotal.innerHTML = `
          <span class="original-price">$${originalSubtotal.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${totalPrice.toFixed(2)}</span>
        `;
        
        // Show and update discount row ONLY for tagged members
        const discountRow = document.getElementById('summary-discount-row');
        const discountLabel = document.getElementById('summary-discount-label');
        const discountAmountEl = document.getElementById('summary-discount-amount');
        
        if (discountRow && discountLabel && discountAmountEl) {
          console.log(`[Discount Debug] Showing accurate total savings for ${memberTier} member: -$${totalSavings.toFixed(2)}`);
          discountRow.style.display = 'flex'; // Show the discount row
          discountLabel.textContent = `${memberTier.toUpperCase()} Member Discount (${memberDiscountPercent}%):`;
          discountAmountEl.textContent = `-$${totalSavings.toFixed(2)}`;
          discountAmountEl.style.color = '#28a745'; // Green color for savings
          discountAmountEl.style.fontWeight = '600'; // Make it stand out
        }
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
        
        // Hide discount row for non-members
        const discountRow = document.getElementById('summary-discount-row');
        if (discountRow) {
          console.log('[Discount Debug] Hiding discount row - no membership tags found');
          discountRow.style.display = 'none';
        }
      }
    }
  }

  async addToCart() {
    const button = document.getElementById('custom-add-to-cart-btn');
    if (!button) return;

    // Validate that a design file is uploaded
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    // File upload is now optional, so skip this check

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      // Get the correct variant ID based on size, print type, and quantity
      const pricingKey = this.getPricingKey();
      const quantityKey = String(this.selectedQuantity);
      
      // Use selected wall mapping
      const mapping = this.getVariantMapping();
      let variantId = mapping[pricingKey]?.[quantityKey];
      let useLidInclusiveVariant = false;
      
      // Note: We used to have special logic for 8oz 10,000 quantity with lids,
      // but this was causing issues where lid variants were added instead of cup variants.
      // Now we always add cups and lids separately for clarity and proper cart functionality.
      
      console.log('[AddToCart Debug] Selected variant ID:', variantId);
      
      if (!variantId) {
        throw new Error(`No variant found for ${this.selectedWall} ${pricingKey} - ${quantityKey} units.`);
      }

      // Recompute live unit price from ProductJSON for selected variant before sending
      try {
        await this.loadProductData();
        const mapping = this.getVariantMapping();
        const pk = this.getPricingKey();
        const selId = mapping[pk]?.[String(this.selectedQuantity)];
        const v = this.productData?.variants?.find(v => v.id.toString() === String(selId));
        if (v) {
          let p = typeof v.price === 'string' ? parseFloat(v.price) : Number(v.price);
          if (p > 100) p = p / 100;
          if (this.selectedQuantity) this.currentUnitPrice = p / this.selectedQuantity;
        }
      } catch (_) {}

      // Create FormData to handle file upload
      const formData = new FormData();

      // Shared group id so the cup, its lids and its rush fee stay linked in the cart
      // (cart grouping + add-on panel + rush removal all key off _epk_group). Without this
      // the rush fee renders as a separate, unlinked card.
      const epkGroup = 'epkorder-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1000000).toString(36);

      // Add the main cup variant
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');
      formData.append('items[0][properties][Wall Type]', this.selectedWall);
      formData.append('items[0][properties][Size]', this.selectedSize);
      formData.append('items[0][properties][Print Type]', this.selectedPrintType);
      formData.append('items[0][properties][Quantity]', this.selectedQuantity);
      formData.append('items[0][properties][Price/Unit]', `$${this.calculateUnitPrice().toFixed(2)}`);
      formData.append('items[0][properties][Production Time]', this.getProductionTimePropertyValue());
      formData.append('items[0][properties][_epk_group]', epkGroup);

      // Lids are always handled separately below
      
      // Add the uploaded file
      if (fileInput.files[0]) {
        formData.append('items[0][properties][Design File]', fileInput.files[0]);
      }

      let itemIndex = 1; // Start next items at index 1

      // Add separate lid variant if lids are required
      if (this.requireLids) {
        const lidQuantityTier = this.getLidQuantityTier(this.selectedQuantity);
        const lidVariantId = this.lidVariantMapping[this.lidColor]?.[lidQuantityTier];
        
        if (lidVariantId) {
          formData.append(`items[${itemIndex}][id]`, lidVariantId);
          formData.append(`items[${itemIndex}][quantity]`, '1');
          formData.append(`items[${itemIndex}][properties][Type]`, 'Lids');
          formData.append(`items[${itemIndex}][properties][Color]`, this.lidColor);
          formData.append(`items[${itemIndex}][properties][Quantity]`, this.selectedQuantity);
          formData.append(`items[${itemIndex}][properties][For Cup Size]`, this.selectedSize);
          formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);

          itemIndex++;
          console.log('[AddToCart Debug] Added lid variant:', lidVariantId);
        } else {
          console.warn('[AddToCart Debug] Lid variant not found for', this.lidColor, lidQuantityTier);
        }
      }

      // Add rush fee as separate product if rushed is selected
      const productionFeePercent = this.getProductionFeePercent();

      if (productionFeePercent > 0) {
        const variantTotalPrice = this.calculateVariantTotalPrice();
        const rushFeeAmount = variantTotalPrice * (productionFeePercent / 100);
        const rushFeeQuantity = Math.round(rushFeeAmount);
        
        formData.append(`items[${itemIndex}][id]`, '50675778126106');
        formData.append(`items[${itemIndex}][quantity]`, rushFeeQuantity);
        formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${variantTotalPrice.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][Production Time]`, this.getProductionTimeLabel());
        formData.append(
          `items[${itemIndex}][properties][Production Fee (${this.getProductionTimeLabel()}) +${productionFeePercent}%]`,
          `$${rushFeeAmount.toFixed(2)}`
        );
        formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);
      }

      // Submit to cart using FormData (supports file uploads)
      const response = await fetch('/cart/add', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add to cart: ${response.status} - ${errorText}`);
      }

      // Success
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Set flag for success state after page refresh
      localStorage.setItem('cartAddSuccess', 'true');
      // Reload page to update cart UI (since we're using form submission)
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }
  
  showMessage(text, type) {
    console.log('showMessage called:', text, type);
    
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.cup-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new toast message
    const message = document.createElement('div');
    message.className = `cup-message cup-${type}-message cup-toast-message`;
    message.textContent = text;
    
    // Position the toast near the Add to cart button
    const addToCartButton = document.querySelector('#custom-add-to-cart-btn') || 
                           document.querySelector('.custom-add-to-cart-button') ||
                           document.querySelector('.product-form-cup__cart-submit') || 
                           document.querySelector('#product-form-cup button[type="submit"]') ||
                           document.querySelector('button[name="add"]');
    
    console.log('Found button:', addToCartButton);
    
    if (addToCartButton) {
      const buttonRect = addToCartButton.getBoundingClientRect();
      console.log('Button rect:', buttonRect);
      
      // Position the toast near the button
      message.style.position = 'fixed';
      message.style.top = `${buttonRect.top + (buttonRect.height / 2) - 30}px`;
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      console.log('Toast appended to body');
      
      // Trigger slide-in animation
      setTimeout(() => {
        message.classList.add('show');
        console.log('Toast show class added');
      }, 10);
      
      // Auto-remove after 3 seconds
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
          console.log('Toast removed');
        }, 300); // Allow fade-out animation to complete
      }, 3000);
    } else {
      console.warn('Add to cart button not found, falling back to simple display');
      // Fallback: just append to body with default positioning
      message.style.position = 'fixed';
      message.style.top = '20px';
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      
      setTimeout(() => {
        message.classList.add('show');
      }, 10);
      
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
        }, 300);
      }, 3000);
    }
  }
  
  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return this.formatNumber(decimal);
    }
    
    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };
    
    return fractions[decimal] || this.formatNumber(decimal);
  }

  updateMediaGalleryForSelectedVariant() {
    // If Double Wall, try to show dedicated hero image first
    if (this.selectedWall === 'Double') {
      const switched = this.switchToAltMedia(this.doubleWallHeroAlt);
      if (switched) {
        return;
      }
    }
    
    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const mapping = this.getVariantMapping();
    const variantId = mapping[pricingKey]?.[quantityKey];
    
    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);
    
    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);
    
    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);
    
    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  switchToAltMedia(altText) {
    try {
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        return false;
      }
      const productData = JSON.parse(productScript.textContent);
      const mediaItem = (productData.media || []).find(m => {
        const alt = (m.alt || '').trim().toLowerCase();
        return alt === (altText || '').trim().toLowerCase();
      });
      if (!mediaItem || !mediaItem.id) {
        return false;
      }

      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        return false;
      }
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${mediaItem.id}`;

      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          button.click();
          return true;
        }
      }
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
        return true;
      }
      // Manual fallback
      this.manualMediaSwitch(targetMediaId);
      return true;
    } catch (e) {
      console.warn('switchToAltMedia failed:', e);
      return false;
    }
  }

  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }
      
      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);
      
      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }
      
      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);
      
      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }
      
      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
      
      console.log('Looking for media with ID:', targetMediaId);
      
      // Find the thumbnail with the matching data-target
      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          console.log('Found thumbnail button, clicking it');
          button.click();
          return;
        }
      }
      
      // Fallback: directly call setActiveMedia if thumbnail click didn't work
      console.log('Thumbnail not found, using direct media switching');
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      } else {
        // Manual fallback
        this.manualMediaSwitch(targetMediaId);
      }
      
    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }
  
  manualMediaSwitch(targetMediaId) {
    console.log('Manual media switch to:', targetMediaId);
    
    // Try to find and activate the target media
    const targetMedia = document.getElementById(targetMediaId);
    if (targetMedia) {
      // Hide all media
      const allMedia = document.querySelectorAll('[id*="-"][id*="media"]');
      allMedia.forEach(media => {
        media.style.display = 'none';
        media.classList.remove('active');
      });
      
      // Show target media
      targetMedia.style.display = 'block';
      targetMedia.classList.add('active');
      
      // Update thumbnails
      const allThumbnails = document.querySelectorAll('[data-target]');
      allThumbnails.forEach(thumb => thumb.classList.remove('active'));
      
      const targetThumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (targetThumbnail) {
        targetThumbnail.classList.add('active');
      }
      
      console.log('Manual media switch completed');
    } else {
      console.log('Target media not found:', targetMediaId);
    }
  }

  checkCartAddSuccess() {
    const successFlag = localStorage.getItem('cartAddSuccess');
    if (successFlag === 'true') {
      localStorage.removeItem('cartAddSuccess');
      this.showMessage('Added to cart successfully!', 'success');
    }
  }

  preventAutoScroll() {
    // Prevent automatic scrolling behaviors that might interfere with user experience
    // But allow manual scrolling functions like scrollToShippingCalculator
    const blockScrollIntoView = () => {
      const originalScrollIntoView = Element.prototype.scrollIntoView;
      Element.prototype.scrollIntoView = function(options) {
        // Allow manual scrolling (when called by our functions)
        if (options && (options.block === 'manual' || options.behavior === 'smooth')) {
          return originalScrollIntoView.call(this, options);
        }
        // Block automatic scrolling
        console.log('Blocked automatic scrollIntoView');
        return;
      };
    };

    // Apply the scroll blocking
    blockScrollIntoView();

    // Also prevent hash-based scrolling on page load
    if (window.location.hash) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1);
    }

    // Prevent scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Block automatic focus scrolling but allow manual focus
    const originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function(options) {
      const newOptions = { ...options, preventScroll: true };
      return originalFocus.call(this, newOptions);
    };
  }
}

// Initialize the product when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Only initialize if we're on a product page with the cup-specific elements
  if (document.querySelector('.size-btn') || document.querySelector('#quantity-grid-body')) {
    new CoffeeCupProduct();
  }
});

// Smooth scroll function for ETA button
function scrollToShippingCalculator(event) {
  event.preventDefault();
  
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Smooth scroll function for ETA calculator
function scrollToEtaCalculator(event) {
  event.preventDefault();
  
  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();
  
  const designUploadSection = document.getElementById('design-upload-section');
  if (designUploadSection) {
    designUploadSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Test function for toast messages
function testToast() {
  const product = new CoffeeCupProduct();
  product.showMessage('Test message!', 'success');
}

// Force bold titles (utility function)
function forceBoldTitles() {
  const titles = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
  titles.forEach(title => {
    title.style.fontWeight = 'bold';
  });
}
